<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner"  title="Our Mission" subtitle="Our Mission" ></app-page-banner>
        <!-- INNER PAGE BANNER END -->
        <!-- <app-page-banner 
        title="Our Mission" 
        subtitle="Our Mission"
        backgroundImage="assets/images/missionn.jpg">
      </app-page-banner> -->
      

        <!-- FAQ SECTION START -->
        <!-- <app-faqs [faqs]="faqs"></app-faqs> -->
        <!-- FAQ SECTION END -->

        <!-- FORM SECTION START -->
        <!-- <app-faq-form></app-faq-form> -->
        <!-- FORM ONE SECTION END -->
      <div class="container pt-0 pb-5">       
        <div class="row align-items-center">
            <!-- Left Side: Image -->
            <div class="col-lg-6 col-md-12 m-b10">
                <div class="image-container text-center mt-5 mb-4 pl-0">
                    <img src="assets/images/mission.png" alt="Welcome to Soul Space" class="img-fluid rounded-img shadow-img">
                </div>
            </div>
        
            <!-- Right Side: Text Content -->
            <div class="col-lg-6 col-md-12">
                <div class="text-content mobcontent" style="position: relative;bottom: 218px;">
                    <div class="separator-line mb-4 mobcontene"></div>
                    <!-- <h5>Our Mission </h5> -->
                    <p>
                        Soul Space Wellness & Behavioural Health Clinic is dedicated to promoting holistic
                        well-being by offering compassionate care for mental, emotional, and physical
                        health. Our goal is to create a safe, healing environment for personal growth and
                        resilience.
                    </p>
        
                    
                </div>
            </div>
        </div>
        
    </div>
               

    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>